import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { KeretService } from '../../keret.service';
import { modeNev, modeFavicon } from '../../mode-nevek';
import { GepjarmuAktiv, GepjarmuService } from '../gepjarmu.service';

/*  GÉPJÁRMŰ (GEPJARMU) – a modul kerete: Fókusz témában sötét sáv a modul ikonjával, fülek, jobbra a cég +
 *  év és a profil; Klasszikusban egyszerű eszköztár (a menüt a bal sáv adja). Közúti tábla-kék arculat; a
 *  modálok a `body.gepjarmu-aktiv` osztályról kapják. A Gépjárműben az ügyfél (a cég sofőrje, ügyintézője) és
 *  a könyvelőiroda munkatársa is ír: a sofőr az útjait és a tankolásait, a könyvelő az elszámolást viszi. */
@Component({
  selector: 'app-gepjarmu-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class GepjarmuLayoutComponent implements OnInit, OnDestroy {
  alrendszerNev = modeNev('GEPJARMU');
  modIkon = modeFavicon('GEPJARMU');
  aktiv: GepjarmuAktiv = { intezmeny: '', ugyfelId: null, ugyfelNev: null, szerep: null, ev: new Date().getFullYear() };
  readonly fulek: { ut: string; cim: string; ikon: string; tobb?: string[] }[] = [
    { ut: '/gepjarmu/kezdolap', cim: 'Kezdőlap', ikon: 'home-outline' },
    { ut: '/gepjarmu/jarmuvek', cim: 'Járművek', ikon: 'car-outline' },
    { ut: '/gepjarmu/utnyilvantartas', cim: 'Útnyilvántartás', ikon: 'map-outline', tobb: ['/gepjarmu/ut-gps'] },
    { ut: '/gepjarmu/ut-gps', cim: 'GPS-út', ikon: 'navigate-outline' },
    { ut: '/gepjarmu/elszamolas', cim: 'Elszámolás', ikon: 'calculator-outline' },
    { ut: '/gepjarmu/kikuldetes', cim: 'Kiküldetés', ikon: 'document-text-outline' },
    { ut: '/gepjarmu/koltsegek', cim: 'Költségek', ikon: 'receipt-outline' },
    { ut: '/gepjarmu/cegautoado', cim: 'Cégautóadó', ikon: 'cash-outline', tobb: ['/gepjarmu/bevallas'] },
    { ut: '/gepjarmu/beallitasok', cim: 'Beállítások', ikon: 'settings-outline', tobb: ['/gepjarmu/soforok', '/gepjarmu/cimtar'] },
  ];
  aktivUt = '';
  evek: number[] = [];

  valasztoNyitva = false;
  ugyfelek: any[] = [];
  kereso = '';

  private sub?: Subscription;
  private navSub?: Subscription;
  constructor(public router: Router, private keret: KeretService, private sz: GepjarmuService) {}

  get fokusz(): boolean { return this.keret.a?.tema() === 'fokusz'; }

  async ngOnInit() {
    /*  Más alrendszerből (pl. a Bér csempéjéről, egy régi /ber/cegauto címről vagy a Klasszikus bal sávból)
     *  nyitva az alrendszert is átváltjuk – különben a menü és a jogosultság a régié maradna. */
    if (this.keret.modulba('GEPJARMU', this.router.url)) return;
    await this.sz.init();
    this.sub = this.sz.aktiv$.subscribe((a) => (this.aktiv = a));
    await this.sz.kozosAtvesz();
    const most = new Date().getFullYear();
    this.evek = [most + 1, most, most - 1, most - 2, most - 3];
    this.utFrissit();
    this.navSub = this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(() => this.utFrissit());
    document.body.classList.add('gepjarmu-aktiv');
    if (!this.aktiv.ugyfelId) this.valasztoNyit();
  }
  ngOnDestroy() { this.sub?.unsubscribe(); this.navSub?.unsubscribe(); document.body.classList.remove('gepjarmu-aktiv'); }
  private utFrissit() { this.aktivUt = this.router.url.split('?')[0]; }
  /** Aktív-e a fül: a saját útvonala vagy a hozzá tartozók (a bevallás a Cégautóadó fülé). */
  fulAktiv(f: { ut: string; tobb?: string[] }): boolean {
    return this.aktivUt === f.ut || !!f.tobb?.some((t) => this.aktivUt === t || this.aktivUt.startsWith(t + '/'));
  }

  /*  Az ügyfélválasztó saját oldal (components/modul-ugyfelek): csempe / lista, keresés, önálló
   *  módban új ügyfél is – a modul ügyfélkör-módja szerint (backend/ugyfeltorzs.js). */
  valasztoNyit() { if (!this.router.url.startsWith('/gepjarmu/ugyfelek')) this.router.navigateByUrl('/gepjarmu/ugyfelek'); }

  get lathatoUgyfelek(): any[] {
    const k = this.kereso.trim().toLowerCase();
    return k ? this.ugyfelek.filter((u) => String(u.nev || '').toLowerCase().includes(k) || String(u.adoszam || '').includes(k)) : this.ugyfelek;
  }
  async ugyfelValaszt(u: any) {
    this.valasztoNyitva = false;
    await this.sz.setAktiv({ ugyfelId: u.id, ugyfelNev: u.nev, szerep: u.szerep });
  }
  async evValt(ev: number) { await this.sz.setAktiv({ ev: Number(ev) }); }
  open(url: string) { this.router.navigateByUrl(url); }
}
